var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,128a16,16,0,1,1-16-16A16.01833,16.01833,0,0,1,80,128Zm112-16a16,16,0,1,0,16,16A16.01833,16.01833,0,0,0,192,112Zm-64,0a16,16,0,1,0,16,16A16.01833,16.01833,0,0,0,128,112Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThree);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iRmxhdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjU2IDI1NiI+CiAgPHBhdGggZD0iTTgwLDEyOGExNiwxNiwwLDEsMS0xNi0xNkExNi4wMTgzMywxNi4wMTgzMywwLDAsMSw4MCwxMjhabTExMi0xNmExNiwxNiwwLDEsMCwxNiwxNkExNi4wMTgzMywxNi4wMTgzMywwLDAsMCwxOTIsMTEyWm0tNjQsMGExNiwxNiwwLDEsMCwxNiwxNkExNi4wMTgzMywxNi4wMTgzMywwLDAsMCwxMjgsMTEyWiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };